module.exports = __webpack_public_path__ + "img/accessory_pants_04.e9336e09.svg";